// src/components/DailyAttendanceReport.js
import React, { useState } from 'react';
import api from '../services/api';
import { Box, Button, Paper, Typography, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Alert } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const DailyAttendanceReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [reportDate, setReportDate] = useState(new Date().toISOString().split('T')[0]); // Default to today

  const fetchReport = async (exportCsv = false) => {
    if (!reportDate) {
      setError('Please select a date.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await api.get(`/api/reports/daily-attendance?report_date=${reportDate}&export=${exportCsv}`, {
        responseType: exportCsv ? 'blob' : 'json',
      });
      
      if (exportCsv) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `attendance_report_${reportDate}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        setReportData(response.data);
      }
    } catch (err) {
      setError('Failed to fetch report data. No attendance may have been recorded for this day.');
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="h5" gutterBottom>Daily Attendance Report</Typography>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          type="date"
          value={reportDate}
          onChange={(e) => setReportDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          label="Select Date"
          size="small"
        />
        <Button onClick={() => fetchReport(false)} disabled={loading} variant="contained">Generate</Button>
        <Button onClick={() => fetchReport(true)} disabled={loading || reportData.length === 0} variant="outlined" startIcon={<DownloadIcon />}>Export</Button>
      </Box>

      {loading && <CircularProgress />}
      {error && <Alert severity="warning">{error}</Alert>}
      
      <TableContainer sx={{ maxHeight: 400 }}>
        <Table stickyHeader size="small">
          <TableHead><TableRow><TableCell>Name</TableCell><TableCell>Email</TableCell><TableCell>Check-In Time</TableCell></TableRow></TableHead>
          <TableBody>
            {reportData.map((row) => (
              <TableRow key={row.ParticipantID} hover>
                <TableCell>{row.FullName}</TableCell>
                <TableCell>{row.EmailAddress}</TableCell>
                <TableCell>{new Date(row.CheckInTime).toLocaleTimeString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default DailyAttendanceReport;